import { CssBaseline, ThemeProvider } from "@mui/material";
import "./style.css";
import HardwareDetails from "./features/HardwareDetails/HardwareDetails";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Client } from "./services/client";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      refetchInterval: false,
      retry: false,
    },
  },
});

export default function Root(props) {
  Client.setAccessToken(props.getAccessToken);

  return (
    <ThemeProvider theme={props.theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <HardwareDetails user={props.user} />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
